import { Pipe, PipeTransform } from '@angular/core';
import {Item} from "../../models/Item";

@Pipe({ name: 'appFilterGroupedItems' })
export class FilterPipe implements PipeTransform {

  private allowedProps = ['isOpenedItem', 'isHiddenObjects', 'isAnotherHiddenObjects'];

  /**
   * Transform
   *
   * @param {any[]} items
   * @param {string} searchText
   * @returns {any[]}
   */
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.map(group => {
      let resultGroup = {key: group.key, value: {}};
      for (let itemId in group.value){
        let item: Item | any = group.value[itemId];
        if ((item.hasOwnProperty('config') && item.config.getTitle().toLowerCase().includes(searchText)) || this.allowedProps.includes(itemId)){
          resultGroup.value[itemId] = item;
        }
      }
      return resultGroup;
      // return it.toLocaleLowerCase().includes(searchText);
    });
  }
}
